import SettingsIcon from '@material-symbols/svg-300/rounded/settings.svg'
import classnames from 'classnames'
import { Formik } from 'formik'
import React, { useState } from 'react'
import ChildCareIcon from '@material-symbols/svg-300/rounded/child_care.svg'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { SelectFormik } from '../../components/basics/Select/Select'
import UserAvatar from '../../components/UserAvatar/UserAvatar'
import Button from '../../components/basics/Button/Button'
import { CheckboxFormik } from '../../components/basics/Checkbox/Checkbox'
import Modal from '../../components/basics/Modal/Modal'
import ProgressBar from '../../components/basics/ProgressBar/ProgressBar'
import { TextInputFormik } from '../../components/basics/TextInput/TextInput'
import SidebarExtension from '../../components/Page/SidebarExtension'
import UserSlug from '../../components/slugs/UserSlug/UserSlug'
import useRoutes from '../../state/useRoutes'

import styles from './TestPage.module.scss'

export function DefaultContent() {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <section className={styles.contentLimited}>
        <h1>Test page</h1>
      </section>

      <section className={styles.contentLimited}>
        <div className={styles.markOutline}>
          <code>@include includes.layout-right</code>

          <p>Layout limited to the right side of the main navigation.</p>

          <p>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
          </p>

          <p>
            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
            ultricies nec, pellentesque eu, pretium quis, sem.
          </p>
        </div>
      </section>

      <section className={classnames(styles.contentLimited)}>
        <div className={styles.card}>
          <h1>Card</h1>
        </div>
      </section>

      <section className={styles.contentFull}>
        <div className={styles.markOutline}>
          <code>@include includes.layout-full</code>

          <p>Full-width layout.</p>

          <p>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
          </p>
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>Text</h1>
        <div className={styles.card}>
          <p className={styles.textHuge}>Huge: Lorem ipsum dolor sit amet</p>
          <p className={styles.textLarge}>Large: Lorem ipsum dolor sit amet</p>
          <p className={styles.textNormal}>Normal: Lorem ipsum dolor sit amet</p>
          <p className={styles.textSmall}>Small: Lorem ipsum dolor sit amet</p>
          <p className={styles.textSmallcaps}>Small Caps: Lorem ipsum dolor sit amet</p>
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>Buttons</h1>

        <div className={styles.card}>
          <div className={styles.buttons}>
            {[
              [undefined, undefined, undefined, undefined],
              ['green', 'orange', 'red', 'purple'],
            ].map((colors) =>
              [false, true].map((filled) =>
                [false, true].map((disabled) =>
                  [false, true].map((loading) =>
                    ['start, text', 'text', 'text, end', 'end'].map((content, idx) => (
                      <div>
                        {[false, true].map((small) => (
                          <>
                            T{' '}
                            <Button
                              disabled={disabled}
                              filled={filled}
                              loading={loading}
                              small={small}
                              color={colors[idx]}
                            >
                              {content.includes('start') && <ChildCareIcon />}
                              {content.includes('text') && 'Buttony'}
                              {content.includes('end') && <ChildCareIcon />}
                            </Button>{' '}
                          </>
                        ))}
                      </div>
                    ))
                  )
                )
              )
            )}
          </div>
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>Form</h1>

        <div className={styles.card}>
          <div className={styles.forms}>
            {[false, true].map((hideLabel) => (
              <Formik
                validate={(values) => {
                  const errors: Record<string, string> = {}
                  if (values.password !== values.repeatPassword) {
                    errors.repeatPassword = 'Passwords do not match'
                  }
                  return errors
                }}
                initialValues={{
                  firstname: '',
                  lastname: '',
                  email: '',
                  emailIsPrivate: false,
                  birthdate: '',
                  color: '',
                  energy: '',
                  noinput: '',
                  password: '',
                  repeatPassword: '',
                  newsletter: false,
                  acceptterms: false,
                  cannotcheck: false,
                }}
                onSubmit={(values) => {
                  console.log(values)
                }}
              >
                {(props) => (
                  <form noValidate onSubmit={props.handleSubmit} onReset={props.handleReset} className={styles.form}>
                    <div>
                      <TextInputFormik hideLabel={hideLabel} name="firstname" label="First Name" required />
                      <TextInputFormik hideLabel={hideLabel} name="lastname" label="Last Name" required />
                    </div>
                    <div>
                      <TextInputFormik hideLabel={hideLabel} type="email" name="email" label="Email" required />
                      <CheckboxFormik name="emailIsPrivate" label="Hide email address from other users" />
                    </div>
                    <div>
                      <TextInputFormik hideLabel={hideLabel} type="date" name="birthdate" label="Birthdate" required />
                    </div>
                    <SelectFormik
                      hideLabel={hideLabel}
                      name="color"
                      label="Favorite Color"
                      options={[
                        { value: '', label: '' },
                        { value: 'red', label: 'Red' },
                        { value: 'green', label: 'Green' },
                        { value: 'blue', label: 'Blue' },
                      ]}
                      required
                    />
                    <div>
                      <TextInputFormik
                        hideLabel={hideLabel}
                        type="password"
                        name="password"
                        label="Password"
                        after={
                          <Button tiny>
                            <SettingsIcon />
                          </Button>
                        }
                        required
                      />
                      <TextInputFormik
                        hideLabel={hideLabel}
                        type="password"
                        name="repeatPassword"
                        label="Repeat Password"
                        required
                        dropdown={
                          <ul>
                            <li>????</li>
                            <li>!!!</li>
                          </ul>
                        }
                      />
                    </div>
                    <div>
                      <TextInputFormik
                        hideLabel={hideLabel}
                        name="energy"
                        label="Energy"
                        placeholder="Your daily energy intake"
                        after={<span>kWh</span>}
                        required
                      />
                      <CheckboxFormik toggle name="emailIsPrivate" label="Toggle" />
                      <CheckboxFormik name="emailIsPrivate" label="Toggle" />
                    </div>
                    <div>
                      <TextInputFormik
                        hideLabel={hideLabel}
                        name="noinput"
                        label="No input possible"
                        placeholder="You can not enter anything here"
                        disabled
                      />
                      <Button small>Click</Button>
                    </div>
                    <CheckboxFormik name="newsletter" label="Receive Newsletter" />
                    <CheckboxFormik name="acceptterms" label="I accept the terms of use." required />
                    <CheckboxFormik name="cannotcheck" label="Can not be checked." disabled />
                    <div>
                      <Button type="submit">Register</Button>
                    </div>
                  </form>
                )}
              </Formik>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>CTAs</h1>

        <div className={styles.card}>
          <div className={styles.ctas}>
            <div>Primary</div>
            <div>
              <Button filled>Confirm</Button>
            </div>
            <div>
              <Button filled>
                <ChildCareIcon />
                Confirm
              </Button>
            </div>
            <div>
              <Button filled>
                Confirm
                <ChildCareIcon />
              </Button>
            </div>
            <div>
              <Button filled>
                <ChildCareIcon />
              </Button>
            </div>
            <div>
              <Button small filled>
                Confirm
              </Button>
            </div>
            <div>
              <Button small filled>
                <ChildCareIcon />
                Confirm
              </Button>
            </div>
            <div>
              <Button small filled>
                Confirm
                <ChildCareIcon />
              </Button>
            </div>
            <div>
              <Button small filled>
                <ChildCareIcon />
              </Button>
            </div>
            <div>Secondary</div>
            <div>
              <Button>Cancel</Button>
            </div>
            <div>
              <Button>
                <ChildCareIcon />
                Cancel
              </Button>
            </div>
            <div>
              <Button>
                Cancel
                <ChildCareIcon />
              </Button>
            </div>
            <div>
              <Button>
                <ChildCareIcon />
              </Button>
            </div>
            <div>
              <Button small>Cancel</Button>
            </div>
            <div>
              <Button small>
                <ChildCareIcon />
                Cancel
              </Button>
            </div>
            <div>
              <Button small>
                Cancel
                <ChildCareIcon />
              </Button>
            </div>
            <div>
              <Button small>
                <ChildCareIcon />
              </Button>
            </div>
            <div>Tertiary</div>
            <div>
              asdy <Button text>See More</Button> Test
            </div>
            <div>
              asdy{' '}
              <Button text small>
                See More
              </Button>{' '}
              Test
            </div>
            <div>
              asdy{' '}
              <Button text>
                See More
                <ChildCareIcon />
              </Button>{' '}
              tesst
            </div>
            <div>
              asdy{' '}
              <Button text small>
                See More
                <ChildCareIcon />
              </Button>{' '}
              Test
            </div>
            <div>
              asdy{' '}
              <Button text>
                <ChildCareIcon />
                See More
              </Button>{' '}
              tesst
            </div>
            <div>
              asdy{' '}
              <Button text small>
                <ChildCareIcon />
                See More
              </Button>{' '}
              Test
            </div>
          </div>
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>ProgressBar</h1>
        <div className={styles.card}>
          <ProgressBar progress={67} />
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>Modal</h1>
        <div className={styles.card}>
          <Button
            onClick={(e) => {
              e.preventDefault()
              setModalOpen(true)
            }}
          >
            Open
          </Button>
          {modalOpen && (
            <Modal onClose={() => setModalOpen(false)}>
              <h1>Hello Modal!</h1>
              <Button onClick={() => setModalOpen(false)}>Close</Button>
            </Modal>
          )}
        </div>
      </section>

      <section className={styles.contentFull}>
        <h1>User Avatar</h1>

        <div className={styles.card}>
          <div className={styles.avatars}>
            {['user', 'advanced_user', 'admin', 'auditor', 'customer_success_manager'].map((role) =>
              ['active', 'inactive'].map((status) =>
                [null, 'https://picsum.photos/seed/02c54c8e-6509-4ad5-ac45-e97e2bbd8efe/194'].map((avatarUrl) => (
                  <div>
                    <UserAvatar
                      user={{ uuid: '1', firstname: 'Berta', lastname: 'Brot', role, avatarUrl, status } as any}
                    />
                    <UserSlug
                      user={{ uuid: '1', firstname: 'Berta', lastname: 'Brot', role, avatarUrl, status } as any}
                    />
                    Test
                  </div>
                ))
              )
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default React.memo(function TestPage() {
  const [skeleton, setSkeleton] = useState(false)

  return (
    <>
      <SidebarExtension>
        <div>
          <button onClick={() => setSkeleton((prev) => !prev)}>Toggle Skeleton</button>
        </div>
      </SidebarExtension>
      <div className={classnames(styles.TestPage, { skeleton })}>
        <DefaultContent />
      </div>
    </>
  )
})

export function TestPageBreadcrumb() {
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.test.url({} as any)}>{t('test')}</Link>
}
